import React from 'react';
import { Link } from 'react-router-dom';
import { Map as MapIcon, Skull } from 'lucide-react';
import { mapPath, monsterPath } from '../../utils/worldFormat';
import type { WorldLookup } from '../../utils/progressionLookup';
const chip = 'inline-flex h-8 items-center gap-1.5 rounded-full border px-3 text-xs font-semibold whitespace-nowrap transition-colors duration-150';

/** Enlace a un mapa por su nombre, solo si existe en los datos cargados. */
export function MapChip({
  name,
  lookup
}: {
  name: string;
  lookup?: WorldLookup;
}) {
  const m = lookup?.map(name);
  if (!m) return <span className={`${chip} border-white/10 text-gray-400`} data-id="element-1298" data-mp="176jivz12wode"><MapIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1299" data-mp="1784d1njhe5aq" />{name}</span>;
  return <Link to={mapPath(m.id)} className={`${chip} border-white/15 text-gray-200 hover:border-[#D4AF37]/50 hover:text-white`} data-id="element-1300" data-mp="12eryy7cfhgw8">
      <MapIcon className="h-3.5 w-3.5 text-[#D4AF37]" aria-hidden="true" data-id="element-1301" data-mp="eoflkgyeyry9" />
      {m.name}
    </Link>;
}

/** Enlace a un monstruo por su nombre, solo si existe en los datos cargados. */
export function MonsterChip({
  name,
  lookup
}: {
  name: string;
  lookup?: WorldLookup;
}) {
  const id = lookup?.monster(name);
  if (id === undefined) return <span className={`${chip} border-white/10 text-gray-400`} data-id="element-1302" data-mp="edvf3krxfdyp"><Skull className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1303" data-mp="eeexf2lho4d9" />{name}</span>;
  return <Link to={monsterPath(id)} className={`${chip} border-white/15 text-gray-200 hover:border-[#D4AF37]/50 hover:text-white`} data-id="element-1304" data-mp="jbersg8z7ioj">
      <Skull className="h-3.5 w-3.5 text-[#D4AF37]" aria-hidden="true" data-id="element-1305" data-mp="3hwgb3sdn09bc" />
      {name}
    </Link>;
}